<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.surveys', 1),
                        href: null,
                    },
                ]"
            />
        </template>

        <SurveyForm :survey="survey" />
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SurveyForm from './partials/SurveyForm.vue';

export default {
    components: {
        SurveyForm,
        PanelPage,
    },
    layout: Layout,
    name: 'Create',
    props: ['students', 'survey', 'meta'],
};
</script>
